import { render, staticRenderFns } from "./dSocialTonesBar.vue?vue&type=template&id=51744832&"
import script from "./dSocialTonesBar.vue?vue&type=script&lang=js&"
export * from "./dSocialTonesBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports